const number = new Intl.NumberFormat("ko-KR");

export function formatCount(n: number): string {
  return number.format(n);
}

export function formatPages(n: number): string {
  return `${number.format(n)}쪽`;
}

export function formatRating(rating: number): string {
  return `★ ${rating.toFixed(1)}`;
}

export function formatBytes(bytes: number): string {
  const units = ["B", "KB", "MB", "GB"];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit++;
  }
  return `${unit === 0 ? value : value.toFixed(1)} ${units[unit]}`;
}

const pad = (n: number) => String(n).padStart(2, "0");

/** `2026-10-09` in the viewer's own time zone. */
export function formatDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** `2026-10-09 14:05` in the viewer's own time zone. */
export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${formatDate(iso)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
